import { Controller } from '@hotwired/stimulus';
import { MQ } from '../tools/MQ';

export const create = () => {
	return class extends Controller {
		static values = {
			bodyClass: String,
		};
		connect() {
			this.delay = 300;
			this.element.addEventListener('mouseenter', this.show);
			this.element.addEventListener('mouseleave', this.hide);
		}

		show = () => {
			clearTimeout(this.shouldHide);
			this.shouldShow = setTimeout(() => {
				if (MQ('lgUp')) {
					this.element.classList.add('is-hover');
					if (this.bodyClassValue) document.body.classList.add(this.bodyClassValue);
				}
			}, this.delay);
		};

		hide = () => {
			clearTimeout(this.shouldShow);
			this.shouldHide = setTimeout(() => {
				if (MQ('lgUp')) {
					this.element.classList.remove('is-hover');
					if (this.bodyClassValue) document.body.classList.remove(this.bodyClassValue);
				}
			}, this.delay);
		};
	};
};
